import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { PreloadAllModules, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { GlobalsService } from './services/globals.service';
import { UtilService } from './services/util.service';
import { SocketIO } from './services/io.service';
import { DatePipe } from '@angular/common';
// // // import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';

// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// const config: SocketIoConfig = { url: 'http://localhost:8988', options: {query: "param1=value1&param2=value2"} };
// const config: SocketIoConfig = { url: 'ws://a.reachme.com:4445'
// // // const config: SocketIoConfig = { url: 'localhost:80'
// // // , options: {
// // //     reconnection: false,
// // //     // reconnectionDelay: 5000,
// // //     // reconnectionDelayMax : 5000,
// // //     // reconnectionAttempts: 100,
// // //     //  transports: ['websocket'] ,
// // //     // query: "Sec-WebSocket-Key=dGhlIHNhbXBsZSBub25jZQ==&param2=2222222",
// // // }}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        IonicModule.forRoot(),
        // // // SocketIoModule.forRoot(config), 
        // BrowserAnimationsModule,
    ],
    providers: [
        GlobalsService,
        UtilService,
        SocketIO,
        DatePipe,
        PreloadAllModules, RouterModule,
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
